export enum Wochentag {
    Montag     = 'Monday',
    Dienstag   = 'Tuesday',
    Mittwoch   = 'Wednesday',
    Donnerstag = 'Thursday',
    Freitag    = 'Friday',
}
